import React, { createContext, useContext, useState, ReactNode } from 'react';

interface NavigationContextType {
    isBlocked: boolean;
    setIsBlocked: (blocked: boolean) => void;
    onBlockedNavigation?: () => void;
    setOnBlockedNavigation: (callback: (() => void) | undefined) => void;
}

const NavigationContext = createContext<NavigationContextType | undefined>(undefined);

interface NavigationProviderProps {
    children: ReactNode;
}

export const NavigationProvider: React.FC<NavigationProviderProps> = ({ children }) => {
    const [isBlocked, setIsBlocked] = useState(false);
    const [onBlockedNavigation, setOnBlockedNavigation] = useState<(() => void) | undefined>(undefined);

    return (
        <NavigationContext.Provider value={{
            isBlocked,
            setIsBlocked,
            onBlockedNavigation,
            setOnBlockedNavigation
        }}>
            {children}
        </NavigationContext.Provider>
    );
};

export const useNavigationContext = () => {
    const context = useContext(NavigationContext);
    if (context === undefined) {
        throw new Error('useNavigationContext must be used within a NavigationProvider');
    }
    return context;
}; 